// extracted by css-extract-rspack-plugin
export default {"name":"DetailsGroup-module__name___vzXaa"};